import { useContext } from 'react';
import { ReportContext } from './../../components/Report/ReportProvider';

function useReport() {
  const { loader, openReport } = useContext(ReportContext);
  return { loader, openReport };
}

export default useReport;
